module.exports = ".username {\n    font-size: 20px;\n}\n\n.address-container {\n    margin-top: 1em;\n\tline-height: 1.3;\n}\n\n.card > .row-content {\n    line-height: 3em;\n}\n\n.more-info {\n    text-align: right;\n}\n\n.more-info > a {\n    margin-right: 10px;\n}\n\n@media only screen and (max-width: 426px){\n\t.more-info > a{\n\t\tfont-size: 11px;\n\t}\n\t.username{\n\t\tfont-size: 18px;\n\t\tmargin-bottom: 0;\n\t}\n\t.subscription{\n\t\tmargin-bottom: 0;\n\t}\n\t\n\taddress{\n\t\tmargin-bottom: 0;\n\t}\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user-info/user-info.component.css
// module id = ./src/app/components/user-info/user-info.component.css
// module chunks = main